import React, { useState } from "react"
import styled, { css } from "styled-components"

import { useStore } from "../zustandStore"

function EventPicker(props) {
  const { event, events } = useStore(state => ({
    event: state.event,
    events: state.events
  }))

  const [isHidden, setIsHidden] = useState(event.isActive && !event.isConcluded)

  const onClickHide = e => {
    e.preventDefault()
    setIsHidden(prevIsHidden => !prevIsHidden)
  }

  return (
    <StyleWrapper className={isHidden ? 'hidden' : ''}>
      <div className={`header ${isHidden ? 'disabled' : ''}`} onClick={onClickHide}>
        <div className='title'>  
          All Events
        </div>
        <div className='hide-button'>
          <div className='label'>
            {isHidden ? <>Show<br/>Events</> : 'Hide'}
          </div>
          <div className='arrow'>
            {isHidden ? <>&rarr;</> : <>&larr;</>}
          </div>
        </div>
      </div>
      <div className={`links-wrapper ${isHidden ? 'disabled' : ''}`}>
        {events.map(eventLinkObj =>
          <a
            key={eventLinkObj.slug}
            href={`/${eventLinkObj.slug}`}
            className={`event-picker-item ${isHidden ? 'collapsed' : ''} ${event.slug === eventLinkObj.slug ? 'selected' : ''}`}
          >
            {eventLinkObj.name}
          </a>
        )}
      </div>
    </StyleWrapper>
  )
}

export default EventPicker

const StyleWrapper = styled.div`
  z-index: 2;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 3;

  font-size: min(1.2em, 6.5vw);
  white-space: nowrap;

  padding: 0.65em;
  border-radius: 0.7em;
  border: 2px solid rgba(200, 200, 200, 0.5);

  user-select: none;

  transition: translate 0.35s, opacity 0.35s;

  &.hidden {
    translate: calc(2.3em - 100%);
    opacity: 0.3;
    &:hover {
      opacity: 1;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    /* margin-bottom: 0.1em; */

    /* negative margin cancelled by padding makes the clickable header expand to fill in the padding of its parent */
    /* 0.65em + 2px is the total thickness of the parent's padding and border */
    margin: calc(-0.65em - 2px);
    padding: calc(0.65em + 2px);;
    border-radius: 0.7em;

    z-index: 3;
    cursor: pointer;
    &:hover {
      color: var(--blue-text);
    }
    &:active {
      color: var(--blue-selected);
    }
  }

  .title {
    transition: color 0.12s !important;
    font-size: 1.35em;
    text-align: left;
    flex-grow: 1;
    padding-right: 1em;
    &.disabled {
      pointer-events: none;
    }
  }
  .hide-button {
    transition: none;
    /* color: #ccc; */
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: center;
    .arrow {
      transition: color 0.12s !important;
      font-size: 1.5em;
      line-height: 0.5em;
    }
    .label {
      white-space: normal;
      line-height: 1.2em;
      transition: color 0.12s !important;
      text-align: center;
      font-size: 0.65em;
      max-width: 2.35em;
      min-width: 2.35em;
    }
  }

  .links-wrapper {
    &.disabled {
      pointer-events: none;
    }
  }

  .event-picker-item {
    transition: color 0.12s !important;
    display: block;
    text-decoration: none;
    &.collapsed {
      visibility: hidden;
      height: 0px;
    }
    &:hover {
      color: var(--blue-text);
    }
    &:active {
      color: var(--blue-selected);
    }
    &.selected {
      cursor: default;
      color: var(--purple-dim);
      pointer-events: none;
      text-decoration: underline;
    }
  }
`